import * as yup from 'yup';

export const updateRoomDesignValidations = yup.object({
  headerImage: yup.string().url().label('Banner'),
  imageURL: yup.string(),
  uploadedFileName: yup.string(),
});

export const bannerImageValidationError = 'Unsupported file format. Please upload PNG files.';
